export function getI18nValue(obj: any, locale: string, key: string): string {
  const { locales = {} } = obj;
  if (typeof locales[locale]?.[key] === 'string') {
    return locales[locale]?.[key];
  }
  return locales[locale]?.[key] || obj[key] || '';
}
